import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'
import { BillableEventCounter } from 'domains/Workspaces'
import { eventsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Events/Routing'

const StructureRaw = () => {
  const { t } = useTranslation(['entity'])

  const { workspaceId } = eventsRoute.useParams()

  return (
    <Content
      HeaderSlot={
        <Header
          title={t('entity:smep.event', { count: 2 })}
          appendix={<BillableEventCounter workspaceId={workspaceId} />}
          disabled
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
